import { BlockHeroEntityHydrated } from "@jackfruit/common"
import { uniqBy } from "lodash"
import React from "react"
import { getAllBackgroundImages, getAllPartnerLogos } from "../utils/helpers"

interface Props {
  config: BlockHeroEntityHydrated
}

const HeroImageWarmup: React.FC<Props> = ({ config }) => {
  const allPartnerLogos = getAllPartnerLogos(config)
  const allBackgroundImages = getAllBackgroundImages(config)

  const allImages = uniqBy([...allBackgroundImages, ...allPartnerLogos], "path")

  return (
    <>
      {allImages.map((image, index) => {
        return <link key={index} rel="preload" as="image" href={image.path} />
      })}
    </>
  )
}

export default HeroImageWarmup
